<template>
  <div :class="b(mods)">
    <div :class="b('content')">
      <slot name="content">
        <div :class="b('text')">
          <slot name="text">
            {{ text }}
          </slot>
        </div>
        <ga-action
          v-if="link && link.href"
          :class="b('link')"
          view="accent"
          :href="link.href"
        >
          {{ link.text }}
        </ga-action>
      </slot>
    </div>
    <ga-action
      v-if="hasCloseButton"
      :class="b('close-button')"
      @click="onCloseButtonClick()"
    >
      <ga-icon :class="b('close-icon')">
        <ga-icon-additional-cross />
      </ga-icon>
    </ga-action>
  </div>
</template>

<script src="./notification.script.js" />

<style module src="./notification.style.scss" lang="scss" />
